module.exports = __webpack_public_path__ + "static/media/banff-bg-graphic-texture.6184891e.svg";